import React from 'react'
import { ConnectedAccounts } from '../../modules/accounts/components/settings/cards/ConnectedAccounts'

const ConnessioniPage: React.FC = () => {
  return (
    <div className='container-xxl'>
      <div className='row'>
        <div className='col-xl-12'>
          <ConnectedAccounts />
        </div>
      </div>
    </div>
  )
}

export default ConnessioniPage